<template>
  <div class="tag-lock">
    <LockIcon class="tag-lock__icon" />
  </div>
</template>

<script setup>
  import LockIcon from '@shared/UI/Svg/ui/Lock.vue';
</script>

<style scoped lang="scss">
  @import './styles';
</style>